import { useCookies } from 'react-cookie';

const SEPARATOR = '|';
export const MultiOrgCookies = 'Zuora-Org-Ids';
export const WorkingOrgCookie = 'Zuora-Working-Org';

export const useMultiOrgCookies = () => {
  const [cookies, setCookies, removeCookie] = useCookies([
    MultiOrgCookies,
    WorkingOrgCookie,
  ]);

  const options = {
    path: '/',
    encode: (value) => value,
  };

  return {
    workingOrg: cookies[WorkingOrgCookie],
    setWorkingOrg: (value: string) => {
      setCookies(WorkingOrgCookie, value, options);
    },
    selectedOrgIds: cookies[MultiOrgCookies]
      ? cookies[MultiOrgCookies].split(SEPARATOR)
      : [],
    setSelectedOrgIds: (value: string[]) => {
      const orgs = value.join(SEPARATOR);
      setCookies(MultiOrgCookies, orgs, options);
    },
    clear: () => {
      removeCookie(MultiOrgCookies, options);
      removeCookie(WorkingOrgCookie, options);
    },
  };
};
